// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle
import { section, container, whiteColor } from 'styles/jss/original/base';

const styles = {
  section,
  container,
  justifyContentBetween: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  colorWhite: {
    color: whiteColor,
    '&:hover': {
      color: whiteColor
    },
    '&:active': {
      color: whiteColor
    },
    '&:visited': {
      color: whiteColor
    }
  },
  button: {
    color: whiteColor,
    '@media (max-width: 360px)': {
      padding: '12px 15px'
    },
    '& svg': {
      width: '15px',
      height: '15px'
    }
  }
};

export default styles;
